import React, { useRef } from "react";
import { usePromptHandlers } from "../model/usePromptHandlers";
import { ExpandingTextarea } from "../../../shared/ui/molecules/ExpandingTextarea";
import "./PromptAreaBase.styles.scss";
import { PromptAreaBaseProps } from "../model/types";

export function PromptAreaBase({
    value,
    onChange,
    onSubmit,
    onBeforeSubmit,
    placeholder = "Type your message…",
    isFocused,
    onFocus,
    onBlur,
    hasList,
    listReverse,
    rightInline,
    renderSendButton,
    className,
    plugins
}: PromptAreaBaseProps) {
    const canSubmit = value.trim().length > 0;
    const { submit, handleKeyDown } = usePromptHandlers({ value, onSubmit, onBeforeSubmit, canSubmit });
    const taRef = useRef<HTMLTextAreaElement | null>(null);

    const wrapperCls = [
        "prompt-area",
        isFocused ? "prompt-area--focused" : "",
        hasList ? "prompt-area--has-list" : "",
        listReverse && hasList ? "prompt-area--list-reverse" : "",
        className ?? ""
    ].join(" ").trim();

    return (
        <div className={wrapperCls} id={"tileTour1"}>
            <ExpandingTextarea
                id={"prompt-area__textarea"}
                ref={taRef}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                onFocus={onFocus}
                onBlur={onBlur}
                placeholder={placeholder}
                className="prompt-area__textarea"
            />
            <div className="prompt-area__actions">
                {rightInline}
                {renderSendButton
                    ? renderSendButton({ disabled: !canSubmit, onClick: () => submit() })
                    : (
                        <button className="prompt-area__send" onClick={() => submit()} disabled={!canSubmit}>
                            Send
                        </button>
                    )}
                <div style={{ display: "flex" }}>
                    {plugins?.map((Plugin, index) => (
                        <React.Fragment key={index}>
                            {Plugin}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}